import { TypedContainer } from "./_Base";
export class ManagerContainer extends TypedContainer {
  set_content(content) {
    super.set_content(content);
  }
}
